import styled from '@emotion/styled';
import { Tooltip, Typography } from '@material-ui/core';
import { ClassAttributes, createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../../theme';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

export const AdoptedBadge: FC<Props> = ({ className }) => {
  return (
    <Tooltip className={className} title={<FormattedMessage id="offer_detail_page.creation.adopted_badge.title" />}>
      <Badge>
        <Label>
          <FormattedMessage id="offer_detail_page.creation.adopted_badge.label" />
        </Label>
      </Badge>
    </Tooltip>
  );
};

const Label = styled(Typography)({
  color: '#fff',
  fontWeight: 400,
});

const Badge = styled('div')({
  backgroundColor: theme.palette.primary.main,
  display: 'inline-block',
  padding: '.25em .4em',
  lineHeight: 1,
  whiteSpace: 'nowrap',
  borderRadius: '.25rem',
});
